export default {

	Home: () => import('@/views/Home.svelte'),
	Calendar: () => import('@/views/Calendar.svelte'),
	Login: () => import('@/views/Login.svelte'),
	Registration: () => import('@/views/Registration.svelte'),
	NotFound: () => import('@/views/NotFound.svelte'),
	//Test: () => import('@/views/Test2.svelte'),
	
	Academy: () => import('@/views/Academy.svelte'),
	SpecialOffers: () => import('@/views/SpecialOffers.svelte'),
	SpecialOffersCourses: () => import('@/views/SpecialOffersCourses.svelte'),
	
	/* system */
	SystemEvents: () => import('@/views/system/Events.svelte'),
	SystemNoticesTemplates: () => import('@/views/system/NoticesTemplates.svelte'),
	SystemRoles: () => import('@/views/system/Roles.svelte'),
	SystemRoleRules: () => import('@/views/system/RoleRules.svelte'),
	SystemRoleNotices: () => import('@/views/system/RoleNotices.svelte'),

	/* profile */
	Profile: () => import('@/views/profile/Profile.svelte'),
	ProfileNotices: () => import('@/views/profile/ProfileNotices.svelte'),
	ProfileTelegram: () => import('@/views/profile/ProfileTelegram.svelte'),

	/* tender */
	TenderSearch: () => import('@/views/tender/Search.svelte'),
	TenderTowork: () => import('@/views/tender/Towork.svelte'),
	TenderFavorites: () => import('@/views/tender/Favorites.svelte'),
	TenderPersonal: () => import('@/views/tender/Personal.svelte'),
	TenderSubscription: () => import('@/views/tender/Subscription.svelte'),
	TenderCollections: () => import('@/views/tender/Collections.svelte'),
	
	/* order */
	Order: () => import('@/views/order/Order.svelte'),
	Orders: () => import('@/views/order/Orders.svelte'),
	OrdersArchive: () => import('@/views/order/Archive.svelte'),
	Tasks: () => import('@/views/order/Tasks.svelte'),
	Minprices: () => import('@/views/order/Minprices.svelte'),
	MinpricesArchive: () => import('@/views/order/MinpricesArchive.svelte'),
	Guarantees: () => import('@/views/order/Guarantees.svelte'),
	
	/* chat */
	Chat: () => import('@/views/chat/Chat.svelte'),

	/* client */
	ClientsCards: () => import('@/views/client/Cards.svelte'),
	ClientsCardEdit: () => import('@/views/client/CardEdit.svelte'),
	ClientsCardAdd: () => import('@/views/client/CardAdd.svelte'),
	
	/* accreditation */
	Accreditation: () => import('@/views/client/Accreditations.svelte'),
	
	/* log */
	Log: () => import('@/views/log/Log.svelte'),

};
